import { Archive, Trash2 } from 'lucide-react';
import { DialogShell } from './DialogShell';

interface ConfirmDialogProps {
  readonly isOpen: boolean;
  readonly onClose: () => void;
  readonly onConfirm: () => void;
  readonly title: string;
  readonly message: string;
  readonly confirmText: string;
  readonly cancelText: string;
  readonly type: 'delete' | 'archive';
  /** 'nested' para apilar sobre otra ventana ya abierta (ej. confirmación sobre un detalle). */
  readonly level?: 'base' | 'nested';
}

export const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText,
  cancelText,
  type,
  level = 'base'
}) => {
  if (!isOpen) return null;

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <DialogShell isOpen={isOpen} onClose={onClose} size="sm" showCloseButton={false} level={level}>
      <div className="flex items-center gap-3 mb-4">
        <div className={`p-2 rounded-lg ${
          type === 'delete'
            ? 'bg-red-100 text-red-600'
            : 'bg-amber-100 text-amber-600'
        }`}>
          {type === 'delete' ? (
            <Trash2 className="w-5 h-5" />
          ) : (
            <Archive className="w-5 h-5" />
          )}
        </div>
        <h3 className="text-lg font-semibold text-slate-900">{title}</h3>
      </div>

      <p className="text-slate-600 mb-6">{message}</p>

      <div className="flex gap-3 justify-end">
        <button
          onClick={onClose}
          className="px-4 py-2 text-sm font-medium text-slate-700 bg-white border border-slate-300 rounded-lg hover:bg-slate-50 transition-colors"
        >
          {cancelText}
        </button>
        <button
          onClick={handleConfirm}
          className={`px-4 py-2 text-sm font-medium text-white rounded-lg transition-colors ${
            type === 'delete'
              ? 'bg-red-600 hover:bg-red-700'
              : 'bg-amber-600 hover:bg-amber-700'
          }`}
        >
          {confirmText}
        </button>
      </div>
    </DialogShell>
  );
};
